export enum Link {
    Root = '/',
    EventTimeline = '/event-timeline',
    StatusDashboard = '/status-dashboard',
    StatusDashboardOverview = '/status-dashboard/overview',
    StatusDashboardPreset = '/status-dashboard/:preset?',
    Map = '/map',
    EventManager = '/event-manager',
    GroupManager = '/group-manager',
    RemoveAccount = '/remove-account',
    EventManagerItem = '/event-manager/:id(\\d+)',
    ChecklistManager = '/checklist-manager',
    ContactList = '/contact-list',

    Flights = '/flights',
    FlightsArrivals = '/arrivals',
    FlightsDepartures = '/departures',
    FlightsTowingList = '/towing-list',
    FlightsStandsGates = '/stands-gates',
    FlightsNotam = '/notam',
    FlightsAll = '/all',

    NotificationPreferences = '/notification-preferences',

    Tasks = '/tasks',
    TasksTimeline = '/tasks/timeline',
    TasksList = '/tasks/list',
    TasksReports = '/tasks/reports',
    TasksListMatch = '/tasks/list/:filter',
    TasksListMatchId = '/tasks/list/:filter/:taskId',
    TasksListMatchIdWithInstance = '/tasks/list/:filter/:parentTaskId/:instanceId',
    TaskListMathIdWithParent = '/tasks/list/:filter/:parentTaskId/:taskId/:instanceId',
    TasksShiftNotes = '/tasks/shift-notes',
    TasksFireFighters = '/tasks/fire-fighters',
    TasksKanban = '/tasks/kanban',
    FOD = '/tasks/fod',
    TaskWeeklyBoard = '/tasks/weekly-board',
    TaskTemplates = '/tasks/templates',
    TaskTemplateDetails = '/tasks/templates/:id',

    DiscountModule = '/discounts',

    WidgetManagement = '/widget-management',

    NoAccess = '/no-access',
}

export interface StatusDashboardLinkParams {
    preset: string
}
